<template>
  <div class="w-100 position-relative">
    <b-navbar sticky>
      <div
        class="text-light bg-secondary container-fluid p-1 d-flex justify-content-between py-3 px-4"
      >
        <div class="d-flex align-items-center text-uppercase">
          <p v-b-toggle.sidebar-1 class="h2 mb-2">
            <b-icon icon="list"></b-icon>
          </p>

          <img
            :src="require('@/assets/img/FMOH-Logo.png')"
            style="max-height: 46px; border-right: 1px solid #dbdbdb; padding-right: 10px"
            class="d-inline-block align-top"
            alt="FMOH"
          />

          <span class="navbar-brand header__title h6 px-3 font-weight-bold"
            >DATA MANAGEMENT INTERFACE</span
          >
        </div>
        <div class="d-flex align-items-center">
          <span style="font-size: 2rem">
            <b-icon icon="bell-fill" style="color: white"> </b-icon>
          </span>
          <b-badge pill variant="danger"><sup>5</sup></b-badge>
          <div>
            <b-dropdown left variant="link" toggle-class="text-decoration-none" no-caret>
              <!-- <template #button-content>
              <div v-if="user.avatar" class="avatar-container">
                <div class="avatar-wrapper">
                  <img :src="'https://i.pravatar.cc/128'" class="user-avatar" />
                  <span class="username">{{ user.username }}skjsdk</span>
                  <i class="el-icon-caret-bottom" />
                </div>
              </div>
              <div v-else id="profileImage" class="rounded-circle mr-2">
                {{ user.username | profile_pic_alt(fullName) }}
              </div>
            </template> -->

              <template #button-content>
                <div class="d-flex text-white align-items-center">
                  <img src="/user.svg" alt="user" />
                  <div class="d-flex flex-column align-items-start pl-2">
                    <strong class="text-capitalize">{{ user.roles[0] }}</strong>
                    <span>{{ user.email }}</span>
                  </div>
                  <i class="el-icon-arrow-down pl-2"></i>
                </div>
              </template>

              <div style="width: 275px">
                <b-dropdown-item class="w-100" href="#" @click="openModal">
                  <b-icon icon="power" aria-hidden="true"></b-icon> Logout
                </b-dropdown-item>
              </div>
            </b-dropdown>
          </div>
        </div>
      </div>
      <SideBar class="sidebar-container" />
    </b-navbar>
    <div v-if="showModal" class="modal-wrapper position-absolute top-0 bottom-0">
      <div class="content">
        <img src="../../../assets/img/caution.png" alt="caution" />
        <h1 class="my-2">Log Out?</h1>
        <p>Are you sure you want to do this?</p>
        <div class="d-flex justify-content-center w-100 gap-4">
          <button class="cancel" @click="closeModal">Cancel</button>
          <button class="logout" @click="logout">Logout</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "./Sidebar";
import { mapGetters } from "vuex";
import { profile_pic_alt } from "../../../filters";

export default {
  components: {
    SideBar,
  },
  filters: {
    profile_pic_alt,
  },
  data() {
    return {
      showModal: false,
    };
  },
  computed: {
    ...mapGetters(["user"]),
    fullName() {
      return `${this.user.name.first} ${this.user.name.last}`;
    },
  },
  methods: {
    logout() {
      this.$store
        .dispatch("user/logout")
        .then(() => {
          this.$router.push("/login");
          this.$store.dispatch("data/reset_state");
          this.$store.dispatch("permission/reset_state");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
ul.dropdown-menu > .show {
  margin-top: 10px;
  background-color: #e9ecef;
  width: 100%;
}

.avatar-container {
  margin-right: 30px;

  .avatar-wrapper {
    margin-top: 5px;
    position: relative;

    .user-avatar {
      cursor: pointer;
      width: 40px;
      height: 40px;
      border-radius: 50px;
    }
    .username {
      color: white;
      padding-left: 5px;
    }

    .el-icon-caret-bottom {
      cursor: pointer;
      position: absolute;
      right: -20px;
      top: 25px;
      font-size: 12px;
    }
  }
}
#profileImage {
  width: 50px;
  height: 50px;
  background: #e9ecef;
  font-size: 16px;
  color: #5b5b58;
  text-align: center;
  line-height: 52px;
}

.modal-wrapper {
  width: 100%;
  height: 100vh;
  background-color: rgba(91, 91, 88, 0.5); /* 50% opacity */
  z-index: 9999;
  position: fixed; /* usually needed for modals */
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-wrapper .content {
  width: 600px;
  height: 395px;
  background-color: white;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.content img {
  width: 82px;
  height: 82px;
}
.content button {
  width: 174px;
  height: 55px;
  border-radius: 5px;
  border: none;
  outline: none;
}
.cancel {
  background-color: white;
}
.logout {
  background: #ee1f1f 0% 0% no-repeat padding-box;
  color: white;
}
</style>
